document.addEventListener('DOMContentLoaded', () => {
  const getCustomContainers = () => document.querySelectorAll('.orderarmor-terms-container');
  const getCheckoutButtons = () => {
    return document.querySelectorAll('button[name="checkout"], #CartDrawer-Checkout, #checkout, .orderArmorCheckout, .cart__checkout-button');
  };

  let orderArmorIsOn = false;

  // Helper to detect if the widget is hidden or missing from the DOM
  const isWidgetHiddenOrMissing = () => {
    const widget = document.querySelector('.orderarmor-widget, #orderArmorWidget, .order-armor-container, [data-app="orderarmor"], .orderarmor-checkout-widget, .Insurify-Widget, shipping-protection-container');
    if (!widget) return true;
    
    const style = window.getComputedStyle(widget);
    return style.display === 'none' || 
           style.visibility === 'hidden' || 
           widget.hasAttribute('hidden') || 
           widget.offsetHeight === 0;
  };

  const validateCheckout = () => {
    const customContainers = getCustomContainers();
    const isCartEmpty = document.querySelector('.drawer.is-empty, #main-cart-footer.is-empty') !== null;

    // Rule: If widget is missing/hidden, uncheck terms, hide container, and always enable checkout
    if (isWidgetHiddenOrMissing()) {
      customContainers.forEach(container => {
        container.style.display = 'none';
        const cb = container.querySelector('.orderarmor-terms-checkbox');
        if (cb) cb.checked = false;

        const ctasWrapper = container.closest('.cart__ctas');
        if (!ctasWrapper) return;

        const checkoutBtns = ctasWrapper.querySelectorAll('button[name="checkout"], #CartDrawer-Checkout, #checkout, .orderArmorCheckout');
        if (!isCartEmpty) {
          checkoutBtns.forEach(btn => {
            btn.disabled = false;
            btn.classList.remove('disabled');
            btn.style.opacity = '1';
            btn.style.pointerEvents = 'auto';
          });
        }
      });
      return;
    }

    if (!orderArmorIsOn) {
      // Insurance is OFF - Show checkbox container
      customContainers.forEach(container => {
        container.style.display = 'block';
        
        const ctasWrapper = container.closest('.cart__ctas');
        if (!ctasWrapper) return;
        
        const cb = container.querySelector('.orderarmor-terms-checkbox');
        const checkoutBtns = ctasWrapper.querySelectorAll('button[name="checkout"], #CartDrawer-Checkout, #checkout, .orderArmorCheckout');

        checkoutBtns.forEach(btn => {
          if (!cb.checked) {
            btn.disabled = true;
            btn.classList.add('disabled');
            btn.style.opacity = '0.5';
            btn.style.pointerEvents = 'none';
          } else if (!isCartEmpty) {
            btn.disabled = false;
            btn.classList.remove('disabled');
            btn.style.opacity = '1';
            btn.style.pointerEvents = 'auto';
          }
        });
      });
    } else {
      // Insurance is ON - Hide checkbox and enable checkout
      customContainers.forEach(container => {
        container.style.display = 'none';
        
        const cb = container.querySelector('.orderarmor-terms-checkbox');
        if (cb) cb.checked = false;

        const ctasWrapper = container.closest('.cart__ctas');
        if (!ctasWrapper) return;

        const checkoutBtns = ctasWrapper.querySelectorAll('button[name="checkout"], #CartDrawer-Checkout, #checkout, .orderArmorCheckout');
        
        if (!isCartEmpty) {
          checkoutBtns.forEach(btn => {
            btn.disabled = false;
            btn.classList.remove('disabled');
            btn.style.opacity = '1';
            btn.style.pointerEvents = 'auto';
          });
        }
      });
    }
  };

  // 1. Listen for the app's custom event
  window.addEventListener('spw-global-toggle-change', (e) => {
    if (e && e.detail !== undefined) {
      if (typeof e.detail === 'boolean') {
        orderArmorIsOn = e.detail;
      } else if (e.detail.checked !== undefined) {
        orderArmorIsOn = e.detail.checked;
      }
    } else {
      const widget = document.querySelector('.orderarmor-widget, #orderArmorWidget, .order-armor-container, [data-app="orderarmor"], .orderarmor-checkout-widget, .Insurify-Widget');
      if (widget) {
        const toggle = widget.querySelector('input[type="checkbox"], [role="switch"]');
        if (toggle) {
          orderArmorIsOn = toggle.checked || toggle.getAttribute('aria-checked') === 'true' || toggle.classList.contains('is-active');
        }
      }
    }
    validateCheckout();
  });

  // 2. Listen to custom checkbox changes
  document.addEventListener('change', (e) => {
    if (e.target.classList.contains('orderarmor-terms-checkbox')) {
      validateCheckout();
    }
  });

  // 3. Shopify cart update events
  if (window.subscribe) {
    window.subscribe('cartUpdate', () => {
      setTimeout(validateCheckout, 500);
      window?.ShippingProtectionRepublic && window.ShippingProtectionRepublic.initShippingProtection();
    });
  }

  // 4. Custom events dispatched by shipping-protection-guard
  ['cart:refresh', 'cart:updated', 'cart:item-added', 'cart-drawer:open'].forEach((evt) => {
    document.addEventListener(evt, () => {
      setTimeout(validateCheckout, 300);
    });
  });

  // 5. Global AJAX Cart Mutation Interceptors (Fetch & XHR)
  const CART_MUTATION_RX = /\/cart\/(add|change|update|clear|get)(\.js)?(\?|$)/i;

  const originalFetch = window.fetch;
  window.fetch = async function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const response = await originalFetch(input, init);
    if (CART_MUTATION_RX.test(url)) {
      setTimeout(validateCheckout, 300);
      setTimeout(validateCheckout, 800); // Safety backup
    }
    return response;
  };

  const OriginalXHR = window.XMLHttpRequest;
  function PatchedXHR() {
    const xhr = new OriginalXHR();
    let _url = '';
    const originalOpen = xhr.open;
    xhr.open = function (method, url, ...rest) {
      _url = url || '';
      return originalOpen.call(this, method, url, ...rest);
    };
    xhr.addEventListener('loadend', function () {
      if (CART_MUTATION_RX.test(_url)) {
        setTimeout(validateCheckout, 300);
        setTimeout(validateCheckout, 800);
      }
    });
    return xhr;
  }
  PatchedXHR.prototype = OriginalXHR.prototype;
  window.XMLHttpRequest = PatchedXHR;

  // 6. Mutation Observer to capture rendering/inject changes dynamically without looping
  const observer = new MutationObserver((mutations) => {
    let shouldValidate = false;
    for (const m of mutations) {
      if (m.addedNodes.length > 0 || m.removedNodes.length > 0) {
        shouldValidate = true;
        break;
      }
    }
    if (shouldValidate) {
      validateCheckout();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Initial validations
  setTimeout(validateCheckout, 500);
  setTimeout(validateCheckout, 1200);
});
